import {inject, Injectable} from "@angular/core";
import ModalService from "./modal.service";
import {LoaderScreenComponent} from "../components/loader-screen/loader-screen.component";

@Injectable({
  providedIn: 'root'
})
export default class LoaderService {
  private readonly modalService: ModalService = inject(ModalService);

  public show(): void {
    this.modalService.open(LoaderScreenComponent,
      null,
      {
        showBackdrop: false,
        layout: {
          fullScreen: true
        }
      });
  }

  public hide(): void {
    this.modalService.close(LoaderScreenComponent);
  }
}
